import { render } from "./UiDropdownDivider.vue?vue&type=template&id=6a1bf944"
const script = {}

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__